define('modules/content_recommendations/modal/play_modal',[
  'backbone',
  'jquery',
  '_',
  'text!./play_modal_template.html',
], function (Backbone, $, _, modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'content-recommendations-play-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'confirmPlay',
    },

    render: function () {
      this.$el.html(this.template({ bookingIds: this.bookingIds }));
      return this;
    },

    confirmPlay: function () {
      if (this.type === 'content_recommendation') {
        Backbone.trigger('changeItemsStatusContentRecommendations', this.bookingIds, true);
      }   
      else {
        Backbone.trigger('changeItemsStatusAds', this.bookingIds, true);
      }
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

